import CalendarDay from '@app/state/calendar/CalendarDay';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';
import React, { useState } from 'react';
import {
	useMarketStateTools
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import { LightBulbIcon } from '@heroicons/react/24/solid';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import { ArrowTrendingDownIcon, ArrowTrendingUpIcon } from '@heroicons/react/24/outline';
import Utilities from '@util/Utilities';

const MarketStateSnapshotDailyRecommendationLiteNotificationFragment: React.FunctionComponent<{
	calendarDay: CalendarDay,
	marketStatDateMainHotelSnapshot: MarketStateStatDateCompetitorSnapshot
}>
	= ({ calendarDay, marketStatDateMainHotelSnapshot }) => {

	const [isExpanded, setIsExpanded] = useState(true);

	const tools = useMarketStateTools();
	const room = marketStatDateMainHotelSnapshot.getLowestItemForRoom();

	const recommendationState = tools.marketStateSnapshot.findPriceRecommendationState(calendarDay.display);

	if (!recommendationState) return null;

	return <div className="rounded-md shadow shadow-cyan-900/20 bg-cyan-50 pt-4 pb-3 px-6 mt-4">
		<div className="flex justify-between items-center">
			<div className="flex justify-start items-start ">
				<div className="flex-shrink-0">
					<LightBulbIcon className='h-5 w-5 text-cyan-400'/>
				</div>
				<div className="ml-2"><h3 className="text-sm font-medium text-cyan-800">Smart alert with priority action</h3>
				</div>
			</div>
			<button type="button" onClick={() => setIsExpanded(!isExpanded)}
							className="rounded-md bg-cyan-50 text-cyan-700 hover:bg-cyan-100 hover:text-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-300 focus:ring-offset-2">
				{isExpanded ? <ChevronUpIcon className="h-6 w-6" /> : <ChevronDownIcon className="h-6 w-6" />}
			</button>
		</div>
		<div className={`mt-4 ${isExpanded ? 'block' : 'hidden'}`}>
			<div className="flex flex-col gap-y-2">
				<div className="relative flex flex-wrap items-center gap-x-3">
					<div className="relative flex items-center gap-x-1"><span className="text-sm font-normal text-cyan-700">Room type:</span>
						<span className="text-sm font-bold text-cyan-800">{Utilities.snakeCaseToWords(room.findRoom(tools.companyHotel).roomMappingName)}</span></div>
					<span className="shrink-0 w-1.5 h-1.5 bg-cyan-400 rounded-full self-center"></span>
					<div className="relative flex items-center gap-x-1">
						<span className="text-sm font-normal text-cyan-700">Action:</span>
						<span className="text-sm font-bold text-cyan-800">{recommendationState.recommendation.direction}</span>
						{recommendationState.recommendation.recommendedChangeRate > 0 && <ArrowTrendingUpIcon className="w-5 h-5 text-cyan-500"/>}
						{recommendationState.recommendation.recommendedChangeRate < 0 && <ArrowTrendingDownIcon className="w-5 h-5 text-cyan-500"/>}
					</div>
				</div>
				{!!recommendationState.recommendation.narrative && <div className="relative"><p className="text-sm font-normal text-cyan-700 italic">{recommendationState.recommendation.narrative}</p></div>}
			</div>
		</div>
	</div>
};

export default MarketStateSnapshotDailyRecommendationLiteNotificationFragment;